function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import map from 'lodash/map';
import get from 'lodash/get';
import first from 'lodash/first';
import FloatingModal from 'components/FloatingModal';
import App from 'modules/App';
import CloudDrive from 'modules/CloudDrive';
import Visit from 'modules/Visit';
import accessTokenShape from 'shapes/accessTokenShape';
import DropdownIcon from 'svg/dropdown.svg';
import EllipseIcon from 'svg/ellipse.svg';
import Hcp from 'modules/Hcp';
import Account from 'modules/Account';
import MetricConversions from 'libs/MetricConversions';
import { getEmptyResult, getLabelForResultType, getResultsOfType } from '../../helpers';
import * as constants from '../../constants';
import messages from '../../messages';
import BloodPressureForm from './Forms/BloodPressureForm';
import LdlForm from './Forms/LdlForm';
import TriglyceridesForm from './Forms/TriglyceridesForm';
import BmiForm from './Forms/BmiForm';
import * as styles from './AdditionalMeasurements.pcss';
var _React_PureComponent;
class AdditionalMeasurements extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps) {
        const { activePatient, activeVisit, floatingModal } = this.props;
        if (floatingModal && (prevProps.activeVisit !== activeVisit && !activeVisit || get(prevProps.activePatient, 'id') !== get(activePatient, 'id'))) {
            this.props.onCloseFloatingModal();
        }
    }
    onDropdownClick(type) {
        const isExpanded = get(this.state, `${type}.isExpanded`);
        this.setState({
            [type]: {
                isExpanded: !isExpanded
            }
        });
    }
    renderHeading() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.additionalMeasurements__heading,
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "brand__h2",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.additionalMeasurements))
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.provideOtherResults))
                })
            ]
        });
    }
    renderRecentResult(recentResult) {
        const { value, unit, date, time } = recentResult;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.additionalMeasurements__recentResult,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(EllipseIcon, {})
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                value,
                                " ",
                                unit
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.additionalMeasurements__recentResultDateTime,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: date
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: time
                        })
                    ]
                })
            ]
        }, `${date}-${time}-${value}-${unit}`);
    }
    renderForm(type) {
        const isExpanded = get(this.state, `${type}.isExpanded`);
        if (!isExpanded) {
            return null;
        }
        let Form;
        switch(type){
            case constants.RESULT_TYPE.BLOOD_PRESSURE:
                Form = BloodPressureForm;
                break;
            case constants.RESULT_TYPE.LDL:
                Form = LdlForm;
                break;
            case constants.RESULT_TYPE.TRIGLYCERIDES:
                Form = TriglyceridesForm;
                break;
            case constants.RESULT_TYPE.BMI:
                Form = BmiForm;
                break;
            default:
                Form = null;
        }
        return /*#__PURE__*/ _jsx(Form, {
            patient: this.props.activePatient,
            phiSet: this.props.phiSet,
            phiSetDocumentId: this.props.phiSetDocumentId,
            metricsConversions: this.metricsConversions,
            onSubmit: this.props.onSubmit,
            onSuccess: this.props.onSuccess
        });
    }
    renderRecentResults(recentResults, type) {
        const isExpanded = get(this.state, `${type}.isExpanded`);
        if (!isExpanded || !recentResults.length) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.additionalMeasurements__recentResults,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.additionalMeasurements__recentResultsHeader,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.recentResults))
                }),
                map(recentResults, (recentResult)=>this.renderRecentResult(recentResult, type))
            ]
        });
    }
    renderSection(type) {
        const results = getResultsOfType(this.props.measurements, type, this.metricsConversions);
        const { value, unit } = first(results) || getEmptyResult();
        const isExpanded = get(this.state, `${type}.isExpanded`);
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.additionalMeasurements__section,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.additionalMeasurements__sectionHeading,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.additionalMeasurements__sectionHeader,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: getLabelForResultType(type)
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.additionalMeasurements__latestValue,
                                    children: [
                                        value,
                                        " ",
                                        unit
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(DropdownIcon, {
                                className: cn(styles.additionalMeasurements__dropdown, {
                                    [styles['additionalMeasurements__dropdown--expanded']]: isExpanded
                                }),
                                onClick: ()=>this.onDropdownClick(type)
                            })
                        })
                    ]
                }),
                this.renderForm(type),
                this.renderRecentResults(results, type)
            ]
        }, type);
    }
    renderContent() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.additionalMeasurements,
            children: [
                this.renderHeading(),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.additionalMeasurements__content,
                    children: [
                        this.renderSection(constants.RESULT_TYPE.BLOOD_PRESSURE),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.additionalMeasurements__separator
                        }),
                        this.renderSection(constants.RESULT_TYPE.LDL),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.additionalMeasurements__separator
                        }),
                        this.renderSection(constants.RESULT_TYPE.TRIGLYCERIDES),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.additionalMeasurements__separator
                        }),
                        this.renderSection(constants.RESULT_TYPE.BMI)
                    ]
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(FloatingModal, {
            floatingModal: this.props.floatingModal,
            className: cn(styles.floatingModal, {
                [styles['floatingModal--activeVisit']]: this.props.activeVisit && this.props.floatingModal
            }),
            headerMessage: messages.headers.visitNotes,
            isDocked: true,
            isFixed: true,
            onClose: this.props.onCloseFloatingModal,
            children: this.renderContent()
        });
    }
    constructor(props){
        super(props);
        this.metricsConversions = new MetricConversions(props.metricsUnits);
        this.state = {
            [constants.RESULT_TYPE.BLOOD_PRESSURE]: {
                isExpanded: false
            },
            [constants.RESULT_TYPE.LDL]: {
                isExpanded: false
            },
            [constants.RESULT_TYPE.TRIGLYCERIDES]: {
                isExpanded: false
            },
            [constants.RESULT_TYPE.BMI]: {
                isExpanded: false
            }
        };
    }
}
_define_property(AdditionalMeasurements, "propTypes", {
    // Explicit props
    activePatient: PropTypes.shape({
        id: PropTypes.string,
        phiSetReferenceKey: PropTypes.string,
        storageProvider: PropTypes.string,
        accessToken: accessTokenShape
    }),
    phiSet: PropTypes.shape({
        visits: PropTypes.arrayOf(Visit.shapes.visit)
    }),
    phiSetDocumentId: PropTypes.string,
    // Implicit props
    floatingModal: App.shapes.floatingModal,
    activeVisit: Visit.shapes.visit,
    measurements: PropTypes.array,
    metricsUnits: PropTypes.object,
    // Implicit actions
    onSubmit: PropTypes.func,
    onSuccess: PropTypes.func,
    onCloseFloatingModal: PropTypes.func
});
const mapStateToProps = (state)=>({
        metricsUnits: Account.selectors.metricsUnits(state),
        measurements: Hcp.selectors.measurements(state),
        activePatient: Hcp.selectors.activePatient(state),
        phiSetDocumentId: Hcp.selectors.phiSetDocumentId(state),
        phiSet: Hcp.selectors.phiSet(state),
        activeVisit: Visit.selectors.activeVisit(state),
        floatingModal: App.selectors.floatingModalSelector(constants.ADDITIONAL_MEASUREMENTS_FM)(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onSubmit: (measurements, phiSet, phiSetDocumentId, patient, visitData, successAction)=>dispatch(CloudDrive.actions.storeMeasurements(measurements, phiSet, phiSetDocumentId, patient, visitData, successAction)),
        onCloseFloatingModal: ()=>dispatch(App.actions.closeFloatingModal(constants.ADDITIONAL_MEASUREMENTS_FM))
    });
const ConnectedAdditionalMeasurements = connect(mapStateToProps, mapDispatchToProps)(injectIntl(AdditionalMeasurements));
export default withStyles(styles)(ConnectedAdditionalMeasurements);
